// Japanese translations - 日本語
export const ja: Record<string, string> = {
  // ==================== COMMON ====================
  'common.loading': '読み込み中...',
  'common.error': 'エラーが発生しました',
  'common.retry': '再試行',
  'common.cancel': 'キャンセル',
  'common.save': '保存',
  'common.continue': '続ける',
  'common.back': '戻る',
  'common.next': '次へ',
  'common.skip': 'スキップ',
  'common.done': '完了',
  'common.yes': 'はい',
  'common.no': 'いいえ',
  'common.ok': 'OK',
  'common.check': 'チェック',
  'common.correct': '正解！',
  'common.incorrect': '不正解',
  'common.tryAgain': 'もう一度',
  'common.start': '開始',
  'common.finish': '終了',
  'common.submit': '送信',

  // ==================== NAVIGATION ====================
  'nav.home': 'ホーム',
  'nav.courses': 'コース',
  'nav.vocabulary': '単語',
  'nav.profile': 'プロフィール',
  'nav.settings': '設定',
  'nav.logout': 'ログアウト',
  'nav.leaderboard': 'ランキング',
  'nav.aiTutor': 'AIチューター',

  // ==================== ONBOARDING ====================
  'onboarding.welcome': 'KoreanFlowへようこそ！',
  'onboarding.selectLanguage': '言語を選択',
  'onboarding.selectLanguageDesc': 'アプリの表示言語を選択',
  'onboarding.selectGoal': '学習目標は何ですか？',
  'onboarding.selectGoalDesc': '学習パスをパーソナライズします',
  'onboarding.takeTest': 'レベルテストを受ける',
  'onboarding.takeTestDesc': '5分で韓国語レベルを確認',
  'onboarding.skipTest': '今はスキップ',
  'onboarding.skipTestDesc': '最初から始める',
  'onboarding.letsGo': 'さあ始めよう！',
  'onboarding.step': 'ステップ',
  'onboarding.of': '/',

  // ==================== LEVEL TEST ====================
  'levelTest.title': 'レベルテスト',
  'levelTest.subtitle': '韓国語レベルを確認しましょう',
  'levelTest.duration': '約5分',
  'levelTest.questions': '問',
  'levelTest.vocabulary': '語彙',
  'levelTest.grammar': '文法',
  'levelTest.listening': 'リスニング',
  'levelTest.speaking': 'スピーキング',
  'levelTest.analyzing': '結果を分析中...',
  'levelTest.yourLevel': 'あなたのレベル',
  'levelTest.congratulations': 'おめでとうございます！',
  'levelTest.resultDesc': 'テスト結果に基づいて',
  'levelTest.startLearning': '学習を始める',
  'levelTest.retakeTest': 'テストを再受験',
  'levelTest.sectionComplete': 'セクション完了',
  'levelTest.nextSection': '次のセクション',
  'levelTest.listenAndAnswer': '聞いて答える',
  'levelTest.speakNow': '話してください',
  'levelTest.tapToListen': 'タップして聞く',

  // ==================== CEFR LEVELS ====================
  'cefr.A1': '入門',
  'cefr.A2': '初級',
  'cefr.B1': '中級',
  'cefr.B2': '中上級',
  'cefr.C1': '上級',
  'cefr.C2': 'マスター',
  'cefr.A1.desc': '基本的な挨拶と簡単な表現',
  'cefr.A2.desc': '日常生活についての簡単な会話',
  'cefr.B1.desc': 'ほとんどの旅行状況に対応できる',
  'cefr.B2.desc': 'ネイティブスピーカーと流暢に会話できる',
  'cefr.C1.desc': '流暢かつ自然にアイデアを表現できる',
  'cefr.C2.desc': 'あらゆる状況でネイティブに近い能力',

  // ==================== LEAGUE / RANKING ====================
  'league.title': 'リーグ',
  'league.weeklyRanking': '週間ランキング',
  'league.bronze': 'ブロンズ',
  'league.silver': 'シルバー',
  'league.gold': 'ゴールド',
  'league.platinum': 'プラチナ',
  'league.diamond': 'ダイヤモンド',
  'league.promotion': '昇格ゾーン',
  'league.demotion': '降格ゾーン',
  'league.safe': 'セーフゾーン',
  'league.weeklyXP': '今週のXP',
  'league.rank': '順位',
  'league.daysLeft': '日残り',
  'league.promoted': '昇格！',
  'league.demoted': '降格',
  'league.stayed': '残留',
  'league.noData': 'ランキングデータなし',
  'league.earnXP': 'XPを獲得してリーグに参加！',
  'league.topPercent': '上位{percent}%',

  // ==================== LANDING PAGE ====================
  'landing.tagline': '#1 韓国語学習アプリ',
  'landing.title': '韓国語を学ぶ',
  'landing.titleAccent': '楽しく',
  'landing.subtitle': 'ミニレッスン、K-Pop＆韓国ドラマコンテンツ、AI発音フィードバックで韓国語をマスター。100万人以上の学習者に参加！',
  'landing.getStarted': '無料で始める',
  'landing.learnMore': '詳細を見る',
  'landing.login': 'ログイン',
  'landing.startFree': '無料で開始',
  'landing.learners': '学習者',
  'landing.lessons': 'レッスン',
  'landing.countries': '国',

  // ==================== FEATURES ====================
  'features.title': 'なぜKoreanFlow？',
  'features.subtitle': 'ゲーミフィケーション、本物のコンテンツ、AI技術を組み合わせた独自のアプローチで、韓国語学習を楽しく効果的に。',
  'features.streaks.title': 'デイリーストリーク',
  'features.streaks.desc': '毎日の目標とストリーク報酬で習慣を作る。XPとジェムでモチベーション維持。',
  'features.folksong.title': '民謡',
  'features.folksong.desc': '伝統的な民謡で韓国語を学ぶ。歌詞と文化を理解しよう！',
  'features.culture.title': '韓国文化',
  'features.culture.desc': 'ことわざ、スラング、必須表現を探求。本物の表現をマスター。',
  'features.ai.title': 'AIチャットボット',
  'features.ai.desc': 'AIチューターと会話練習。即座にフィードバックと修正を受ける。',
  'features.leaderboard.title': 'リーダーボード',
  'features.leaderboard.desc': '友達や世界中の学習者と競争。週間ランキングを駆け上がろう！',
  'features.srs.title': 'SRS単語帳',
  'features.srs.desc': 'スマート復習システムで学んだことを永久に記憶。',
  'features.pronunciation.title': '発音フィードバック',
  'features.pronunciation.desc': 'AI駆動の発音分析で詳細なスコアリング。',

  // ==================== CTA ====================
  'cta.title': '旅を始める準備はできましたか？',
  'cta.subtitle': '何百万人もの学習者に参加して、今日から韓国語を話し始めましょう。無料！',
  'cta.button': '無料で学習開始',

  // ==================== AUTH ====================
  'auth.login': 'ログイン',
  'auth.register': '登録',
  'auth.email': 'メール',
  'auth.emailPlaceholder': 'メールアドレスを入力',
  'auth.password': 'パスワード',
  'auth.passwordPlaceholder': 'パスワードを作成',
  'auth.confirmPassword': 'パスワード確認',
  'auth.forgotPassword': 'パスワードをお忘れですか？',
  'auth.noAccount': 'アカウントがありませんか？',
  'auth.haveAccount': 'すでにアカウントをお持ちですか？',
  'auth.orContinueWith': 'または続行',
  'auth.google': 'Google',
  'auth.apple': 'Apple',
  'auth.createAccount': 'アカウント作成',
  'auth.createAccountTitle': 'アカウントを作成',
  'auth.createAccountSubtitle': '今日から韓国語学習の旅を始めましょう',
  'auth.username': 'ユーザー名',
  'auth.usernamePlaceholder': 'ユーザー名を選択',
  'auth.usernameHint': '英字、数字、アンダースコアのみ',
  'auth.passwordHint': '大文字、小文字、数字を含む8文字以上',
  'auth.nativeLanguage': '母国語',
  'auth.nativeLanguageHint': 'この言語で説明を表示します',
  'auth.termsAgree': '登録することで、以下に同意したことになります',
  'auth.terms': '利用規約',
  'auth.and': 'と',
  'auth.privacyPolicy': 'プライバシーポリシー',
  'auth.loginTitle': 'おかえりなさい',
  'auth.loginSubtitle': 'ログインして学習を続けましょう',
  'auth.loginButton': 'ログイン',
  'auth.registerButton': '登録',
  'auth.rememberMe': 'ログイン状態を保持',

  // ==================== DASHBOARD ====================
  'dashboard.welcome': 'おかえりなさい',
  'dashboard.todayGoal': '今日の目標',
  'dashboard.streak': 'ストリーク',
  'dashboard.days': '日',
  'dashboard.xp': 'XP',
  'dashboard.level': 'レベル',
  'dashboard.continueLearning': '学習を続ける',
  'dashboard.recommended': 'おすすめ',
  'dashboard.myCourses': 'マイコース',
  'dashboard.seeAll': 'すべて見る',
  'dashboard.dailyGoalComplete': '今日の目標達成！',
  'dashboard.keepGoing': '続けよう！',
  'dashboard.yourLevel': 'あなたのレベル',
  'dashboard.weeklyProgress': '今週の進捗',

  // ==================== COURSES ====================
  'courses.title': 'すべてのコース',
  'courses.search': 'コースを検索...',
  'courses.all': 'すべて',
  'courses.beginner': '入門',
  'courses.elementary': '初級',
  'courses.intermediate': '中級',
  'courses.advanced': '上級',
  'courses.lessons': 'レッスン',
  'courses.enrolled': '登録済み',
  'courses.progress': '進捗',
  'courses.completed': '完了',
  'courses.recommended': 'おすすめ',
  'courses.forYourLevel': 'あなたのレベル向け',
  'courses.locked': 'ロック中',
  'courses.unlockWith': 'プレミアムで解除',

  // ==================== LESSON ====================
  'lesson.loading': 'レッスン読み込み中...',
  'lesson.notFound': 'レッスンが見つかりません',
  'lesson.quit': '終了しますか？進捗は失われます。',
  'lesson.complete': 'レッスン完了！',
  'lesson.perfect': 'パーフェクト！',
  'lesson.amazing': 'すごい！全問正解！',
  'lesson.xpEarned': '獲得XP',
  'lesson.accuracy': '正答率',
  'lesson.correct': '正解',
  'lesson.goBack': '戻る',
  'lesson.skip': 'スキップ',
  'lesson.unknownType': '不明な問題タイプ',

  // ==================== EXERCISES ====================
  'exercise.tapToReveal': 'タップして答えを表示',
  'exercise.matchPairs': 'ペアをマッチ',
  'exercise.matched': 'マッチ済み',
  'exercise.arrangeWords': '単語を並べ替え',
  'exercise.speak': '話す',
  'exercise.listening': '聞いています...話してください！',
  'exercise.processing': '音声を処理中...',
  'exercise.tapToSpeak': 'タップして話す',
  'exercise.cantSpeak': '今話せませんか？スキップ',
  'exercise.again': 'もう一度',
  'exercise.gotIt': '分かった！',

  // ==================== PRONUNCIATION ====================
  'pronunciation.title': '発音練習',
  'pronunciation.subtitle': 'AIフィードバックで韓国語の発音を向上',
  'pronunciation.selectLevel': 'レベルを選択',
  'pronunciation.beginner': '入門',
  'pronunciation.intermediate': '中級',
  'pronunciation.advanced': '上級',
  'pronunciation.score': 'あなたのスコア',
  'pronunciation.accuracy': '正確さ',
  'pronunciation.fluency': '流暢さ',
  'pronunciation.intonation': 'イントネーション',
  'pronunciation.feedback': 'フィードバック',
  'pronunciation.tryAgain': 'もう一度',
  'pronunciation.next': '次へ',
  'pronunciation.listen': '聞く',
  'pronunciation.slow': 'スロー',
  'pronunciation.sessionComplete': 'セッション完了！',
  'pronunciation.bestScore': '最高スコア',
  'pronunciation.average': '平均',
  'pronunciation.attempts': '試行回数',
  'pronunciation.practiceAgain': 'もう一度練習',
  'pronunciation.changeLevel': 'レベルを変更',
  'pronunciation.tips': '発音のコツ',
  'pronunciation.tip1': 'まず音声を聞く',
  'pronunciation.tip2': 'はっきりと一定のペースで話す',
  'pronunciation.tip3': '難しい単語はスロー再生を使う',
  'pronunciation.tip4': '静かな環境で練習する',

  // ==================== VOCABULARY ====================
  'vocab.title': '単語帳',
  'vocab.totalWords': '総単語数',
  'vocab.mastered': '習得済み',
  'vocab.dueToday': '今日の復習',
  'vocab.reviewSession': '復習セッション',
  'vocab.wordsDue': '語復習予定',
  'vocab.startReview': '復習開始',
  'vocab.allCaughtUp': '完了！',
  'vocab.noWordsDue': '復習予定の単語なし',
  'vocab.sessionComplete': 'セッション完了！',
  'vocab.allWords': 'すべての単語',

  // ==================== PROFILE ====================
  'profile.title': 'プロフィール',
  'profile.level': 'レベル',
  'profile.xpToNext': '次のレベルまで',
  'profile.totalXp': '総XP',
  'profile.currentStreak': '現在のストリーク',
  'profile.lessonsDone': '完了レッスン',
  'profile.timeLearned': '学習時間',
  'profile.achievements': '実績',
  'profile.settings': '設定',
  'profile.dailyGoals': 'デイリー目標',
  'profile.allAchievements': 'すべての実績',
  'profile.logOut': 'ログアウト',
  'profile.koreanLevel': '韓国語レベル',

  // ==================== SETTINGS ====================
  'settings.title': '設定',
  'settings.language': 'アプリ言語',
  'settings.preferences': '設定',
  'settings.sound': 'サウンド',
  'settings.soundEffects': '効果音',
  'settings.soundEffectsDesc': '問題回答時に音を再生',
  'settings.notifications': '通知',
  'settings.notificationsDesc': '毎日の学習リマインダーを受信',
  'settings.darkMode': 'ダークモード',
  'settings.darkModeDesc': '見やすいダークテーマ',
  'settings.dailyReminder': 'デイリーリマインダー',
  'settings.account': 'アカウント',
  'settings.editProfile': 'プロフィール編集',
  'settings.privacy': 'プライバシー',
  'settings.help': 'ヘルプ',
  'settings.about': 'について',
  'settings.retakeTest': 'レベルテスト再受験',
  'settings.retakeTestDesc': '現在の韓国語レベルを確認',
  'settings.terms': '利用規約',

  // ==================== FOOTER ====================
  'footer.privacy': 'プライバシー',
  'footer.terms': '利用規約',
  'footer.contact': 'お問い合わせ',
  'footer.rights': 'All rights reserved.',

  // ==================== QUICK ACTIONS ====================
  'quickAction.vocabulary': '単語帳',
  'quickAction.reviewWords': '単語を復習',
  'quickAction.allCourses': 'すべてのコース',
  'quickAction.browseLessons': 'レッスンを見る',

  // ==================== COURSE DETAIL ====================
  'courseDetail.notFound': 'コースが見つかりません',
  'courseDetail.lessons': 'レッスン',
  'courseDetail.completed': '完了',

  // ==================== BOTTOM NAVIGATION ====================
  'bottomNav.home': 'ホーム',
  'bottomNav.courses': 'コース',
  'bottomNav.vocab': '単語',
  'bottomNav.profile': 'マイ',

  // ==================== AI TUTOR ====================
  'aiTutor.title': 'AIチューター',
  'aiTutor.selectScenario': 'シナリオを選択',
  'aiTutor.freeTalk': 'フリートーク',
  'aiTutor.cafe': 'カフェで注文',
  'aiTutor.shopping': 'ショッピング',
  'aiTutor.restaurant': 'レストラン',
  'aiTutor.friends': '友達を作る',
  'aiTutor.interview': '就職面接',
  'aiTutor.typeMessage': 'メッセージを入力...',
  'aiTutor.send': '送信',

  // ==================== ERRORS ====================
  'error.generic': '問題が発生しました',
  'error.network': 'ネットワークエラー。接続を確認してください。',
  'error.notFound': 'ページが見つかりません',
  'error.unauthorized': 'ログインしてください',
  'error.microphoneAccess': 'マイクへのアクセスが拒否されました',
  'error.speechNotSupported': '音声認識がサポートされていません。Chromeブラウザをお試しください。',

  // ==================== COOKIE CONSENT ====================
  'cookie.title': 'Cookieを使用しています',
  'cookie.description': '体験の向上、サイトトラフィックの分析、コンテンツのパーソナライズのためにCookieを使用しています。必須でないCookieを受け入れるか拒否するかを選択できます。',
  'cookie.learnMore': '詳細を見る',
  'cookie.acceptAll': 'すべて受け入れる',
  'cookie.rejectAll': 'すべて拒否',
  // ==================== ADDED (i18n audit 2026-10-24) ====================
  'nav.learn': '学習',
  'nav.culture': '文化',
  'nav.chat': '会話',
  'nav.ranking': 'ランキング',
  'nav.family': 'ファミリー',
  'nav.premium': 'プレミアム',
  'home.greeting': 'こんにちは',
  'home.streak': '日連続',
  'home.dailyGoal': '今日の目標',
  'home.myLanguages': '学習中の言語',
  'home.addLanguage': '言語を追加',
  'home.recommended': 'おすすめ',
  'home.continue': '学習を続ける',
  'home.selectLanguage': '言語を選択',
  'home.totalXp': '合計XP',
  'home.bestStreak': '最長連続記録',
  'home.level': 'レベル',
  'chat.aiTutor': 'AIチューター',
  'chat.aiTutorDesc': 'AIと会話を練習',
  'onboarding.welcome.subtitle': 'AI会話でどんな言語も学べる',
  'onboarding.selectUILanguage': '言語を選択',
  'onboarding.selectUILanguage.subtitle': 'アプリの表示言語に使われます',
  'onboarding.selectLearningLanguage': '何を学びたいですか？',
  'onboarding.selectLearningLanguage.subtitle': '複数の言語を学べます',
  'onboarding.selectDailyGoal': '毎日の目標を設定',
  'onboarding.selectDailyGoal.subtitle': '1日にどのくらい学べますか？',
  'onboarding.ready': '準備完了！',
  'onboarding.ready.subtitle': '言語学習の旅を始めましょう',
  'onboarding.features.languages': '4言語',
  'onboarding.features.aiTutor': 'AIチューター',
  'onboarding.features.dailyGoals': '毎日の目標',
  'dailyGoal.5min': '5分',
  'dailyGoal.10min': '10分',
  'dailyGoal.15min': '15分',
  'dailyGoal.20min': '20分',
  'dailyGoal.casual': 'のんびりペース',
  'dailyGoal.regular': 'ふだんの練習',
  'dailyGoal.serious': '本気で学ぶ',
  'dailyGoal.intense': '集中トレーニング',
  'learn.title': '学習',
  'learn.currentLevel': '現在のレベル',
  'learn.noCoursesYet': '近日公開！',
  'learn.noCoursesDescription': 'この言語のコースを準備中です。',
  'learn.lessonsCompleted': 'レッスン完了',
  'learn.startCourse': 'コースを始める',
  'learn.continueCourse': '続ける',
  'learn.courseCompleted': '完了',
  'learn.locked': 'ロック中',
  'learn.unlockBy': '前のコースを完了すると解除されます',
  'course.progress': '進捗',
  'course.lessons': 'レッスン',
  'course.lessonsCompleted': 'レッスン完了',
  'course.noLessons': 'レッスンを準備中です…',
  'lesson.tapToReveal': 'タップして意味を表示',
  'lesson.examples': '例文',
  'lesson.questionsCorrect': '正解',
  'lesson.wordsLearned': '単語',
  'lesson.grammarPoints': '文法',
  'lesson.backToCourse': 'コースに戻る',
  'lesson.practiceAgain': 'もう一度練習',
  'lesson.whatYouLearn': '学べること',
  'lesson.newWords': '新しい単語',
  'lesson.exercises': '練習問題',
  'lesson.startLesson': 'レッスンを始める',
  'lesson.reviewLesson': 'レッスンを復習',
  'lesson.learnVocabulary': '単語を学ぶ',
  'lesson.grammarPoint': '文法ポイント',
  'lesson.practice': '練習',
  'profile.guest': 'ゲスト',
  'profile.days': '日',
  'profile.longestStreak': '最長',
  'profile.lessonsCompleted': '完了',
  'profile.dailyGoal': '今日の目標',
  'profile.learningLanguages': '学習中の言語',
  'profile.noLanguages': '言語が選択されていません',
  'profile.minutesPerDay': '分/日',
  'profile.learningHistory': '学習履歴',
  'profile.viewProgress': '進捗を見る',
  'profile.appSettings': 'アプリ設定',
  'profile.languageNotifications': '言語・通知',
  'profile.loginToSave': 'ログインして進捗を保存',
  'settings.learning': '学習',
  'settings.dailyGoal': '今日の目標',
  'settings.minutesPerDay': '1日あたりの分数',
  'settings.selectLanguage': '言語を選択',
  'settings.selectDailyGoal': '毎日の目標を設定',
  'settings.perDay': '1日あたり',
  'settings.appInfo': 'アプリ情報',
  'settings.logout': 'ログアウト',
};

export default ja;
